import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogOut from './logout';
import './layout.scss';
import './modeColor/layout-color.css';
import { Alert, IcoLoadingLogo, Loading } from '../component';
import { setModeScreen } from './redux/layoutActions';
import useScreenType from '../hooks/useScreenType';

const Layout = ({ children }: any) => {
  const dispatch = useDispatch();
  const { load } = useSelector((state: any) => state.layoutState);
  const [heigthHeader, setHeigthHeader]: any = useState(0);
  const screenType = useScreenType(920);

  useEffect(() => {
    dispatch(setModeScreen(screenType));
  }, [screenType]);

  useEffect(() => {
    const boxHeader = document.getElementById('box-header');
    setHeigthHeader(boxHeader?.offsetHeight);
  }, []);
  const heightApp = { height: `calc(100vh - ${heigthHeader}px)` };

  return (
    <>
      {load ? <Loading icon={<IcoLoadingLogo cy="Layout" />} /> : null}
      <Alert />
      <div id="box-app" style={heightApp}>
        <section id="box-container" style={heightApp}>
          {children}
        </section>
        <LogOut />
      </div>
    </>
  );
};

export default Layout;
